module.exports = __webpack_public_path__ + "static/award2020_banner-16fcfdbd05707242d232fc524e1f7821.jpg";